import { injectScope } from "@/utils/lang/util";
import type { Lang } from "@noli/core";

export enum Wenxin_Words {
  "wenxin-title" = "wenxin-title",
  "wenxin-title2" = "wenxin-title2",
  "wenxin-resolution" = "wenxin-resolution",
  "wenxin-submit" = "wenxin-submit",
  "wenxin-submit2" = "wenxin-submit2",
  "wenxin-error-message" = "wenxin-error-message",
  "wenxin-balance-not-enough-message" = "wenxin-balance-not-enough-message",
  "creator-wenxin-task" = "creator-wenxin-task",
  "creator-wenxin-img2img-task" = "creator-wenxin-img2img-task",
  "wenxin-model" = "wenxin-model",
  "wenxin-model-intro" = "wenxin-model-intro",
}

injectScope("wenxin", Wenxin_Words);

// 要记得把这个 xxxLangRecords，引用到 src\thirdParty\lang.ts 中的 allThirdPartyLangRecords 里头

export const wenxinLangRecords: Record<Lang, Record<Wenxin_Words, string>> = {
  zh: {
    [Wenxin_Words["wenxin-title"]]: "百度文心",
    [Wenxin_Words["wenxin-title2"]]: "ERNIE-ViLG",
    [Wenxin_Words["wenxin-resolution"]]: "生成分辨率：",
    [Wenxin_Words["wenxin-submit"]]: "生成 3 张图片",
    [Wenxin_Words["wenxin-submit2"]]: "消耗 3 画力星",
    [Wenxin_Words["wenxin-error-message"]]: "文心生成遇到了一些问题，请再试一次 😫",
    [Wenxin_Words["wenxin-balance-not-enough-message"]]: "您的画力星余额不足 😫",
    [Wenxin_Words["creator-wenxin-task"]]: "文生图（百度文心）",
    [Wenxin_Words["creator-wenxin-img2img-task"]]: "垫图生成（百度文心）",
    [Wenxin_Words["wenxin-model"]]: "百度文心 ERNIE-ViLG",
    [Wenxin_Words["wenxin-model-intro"]]: "百度文心 AI 绘画大模型 ERNIE-ViLG 2.0",
  },
  en: {
    [Wenxin_Words["wenxin-title"]]: "Baidu Wenxin",
    [Wenxin_Words["wenxin-title2"]]: "ERNIE-ViLG",
    [Wenxin_Words["wenxin-resolution"]]: "Resolution: ",
    [Wenxin_Words["wenxin-submit"]]: "Generate 3",
    [Wenxin_Words["wenxin-submit2"]]: "With 3 WnX credits",
    [Wenxin_Words["wenxin-error-message"]]:
      "Something is wrong when using Wenxin, please try again 😫",
    [Wenxin_Words["wenxin-balance-not-enough-message"]]: "Wenxin Credits are not enough 😫",
    [Wenxin_Words["creator-wenxin-task"]]: "Text to Image(Baidu Wenxin)",
    [Wenxin_Words["creator-wenxin-img2img-task"]]: "Image Translation(Baidu Wenxin)",
    [Wenxin_Words["wenxin-model"]]: "Baidu Wenxin ERNIE-ViLG",
    [Wenxin_Words["wenxin-model-intro"]]: "Baidu Wenxin ERNIE-ViLG 2.0",
  },
};
